/**
 * v-dica-truncada — mostra o texto completo num balão (estilo do sistema, não o "title" amarelo do browser)
 * SÓ quando o texto do elemento está cortado (não coube e virou "…").
 *
 * Uso: <span class="menu-rotulo" v-dica-truncada>{{ item.label }}</span>
 *      <span v-dica-truncada="'texto opcional diferente do visível'">…</span>
 *
 * O elemento precisa ser block/inline-block com overflow hidden + text-overflow: ellipsis (ex.: .menu-rotulo),
 * senão não há como medir o corte. O hover vale para o link inteiro (closest('a')), não só para o texto.
 * Posição: à direita do item (menu vertical); se não couber, embaixo (menu horizontal / borda da tela).
 */
import './dicaTruncada.css';

let balao = null;
let alvoAtual = null;

function garanteBalao() {
    if (balao) return balao;
    balao = document.createElement('div');
    balao.className = 'lf-dica';
    balao.setAttribute('role', 'tooltip');
    document.body.appendChild(balao);
    return balao;
}

const estaTruncado = (el) => el.scrollWidth > el.clientWidth + 1;

function mostra(el) {
    const texto = (el._dicaTexto || el.textContent || '').trim();
    if (!texto || !estaTruncado(el)) return;

    const b = garanteBalao();
    b.textContent = texto;
    b.classList.remove('lf-dica--visivel', 'lf-dica--direita', 'lf-dica--baixo');
    // mede fora da tela antes de posicionar
    b.style.left = '-9999px';
    b.style.top = '0px';

    const r = el.getBoundingClientRect();
    const larg = b.offsetWidth;
    const alt = b.offsetHeight;
    const margem = 10;
    const borda = 8;
    let left;
    let top;
    let lado;

    if (r.right + margem + larg <= window.innerWidth - borda) {
        lado = 'direita';
        left = r.right + margem;
        top = r.top + r.height / 2 - alt / 2;
    } else {
        lado = 'baixo';
        left = Math.min(Math.max(borda, r.left + r.width / 2 - larg / 2), window.innerWidth - larg - borda);
        top = r.bottom + margem;
    }
    top = Math.max(borda, Math.min(top, window.innerHeight - alt - borda));

    b.style.left = `${left}px`;
    b.style.top = `${top}px`;
    // setinha apontando para o centro do item, mesmo quando o balão encosta na borda da tela
    b.style.setProperty('--lf-dica-seta-x', `${Math.min(Math.max(12, r.left + r.width / 2 - left), larg - 12)}px`);
    b.style.setProperty('--lf-dica-seta-y', `${Math.min(Math.max(10, r.top + r.height / 2 - top), alt - 10)}px`);
    b.classList.add(`lf-dica--${lado}`);
    alvoAtual = el;
    requestAnimationFrame(() => {
        if (alvoAtual === el) b.classList.add('lf-dica--visivel');
    });
}

function esconde(el) {
    if (!balao || (el && alvoAtual !== el)) return;
    balao.classList.remove('lf-dica--visivel');
    alvoAtual = null;
}

// rolar a página/menu ou redimensionar: o balão perderia a posição — some
window.addEventListener('scroll', () => esconde(), true);
window.addEventListener('resize', () => esconde());

export default {
    mounted(el, binding) {
        el._dicaTexto = typeof binding.value === 'string' ? binding.value : null;
        const gatilho = el.closest('a') || el;
        el._dicaHandlers = {
            gatilho,
            entra: () => mostra(el),
            sai: () => esconde(el),
        };
        gatilho.addEventListener('mouseenter', el._dicaHandlers.entra);
        gatilho.addEventListener('mouseleave', el._dicaHandlers.sai);
        gatilho.addEventListener('focus', el._dicaHandlers.entra);
        gatilho.addEventListener('blur', el._dicaHandlers.sai);
        gatilho.addEventListener('click', el._dicaHandlers.sai);
    },
    updated(el, binding) {
        el._dicaTexto = typeof binding.value === 'string' ? binding.value : null;
    },
    beforeUnmount(el) {
        const h = el._dicaHandlers;
        if (!h) return;
        h.gatilho.removeEventListener('mouseenter', h.entra);
        h.gatilho.removeEventListener('mouseleave', h.sai);
        h.gatilho.removeEventListener('focus', h.entra);
        h.gatilho.removeEventListener('blur', h.sai);
        h.gatilho.removeEventListener('click', h.sai);
        esconde(el);
    },
};
